import { useLocation } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import { PAGE_META, normalisePath } from './pageMeta';

// Applies the per-page title / description / canonical from seo/pageMeta.js
// for the current route. Renders nothing. Pages that manage their own SEO
// (landing pages, property pages) aren't in PAGE_META, so this never fights
// them. The build-time prerender (frontend/scripts/prerender.js) captures the result.

function ApplySeo({ meta }) {
  useSeo(meta);
  return null;
}

export default function RouteSeo() {
  const { pathname } = useLocation();
  const meta = PAGE_META[normalisePath(pathname)];
  return meta ? <ApplySeo meta={meta} /> : null;
}
